import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"plus\"><g data-name=\"Layer 2\" fill=\"none\" stroke-linecap=\"round\" stroke-width=\"13\"><circle cx=\"200\" cy=\"200\" r=\"113.54\" stroke-linejoin=\"round\" /><path stroke-miterlimit=\"10\" d=\"M164.22 200h71.56M200 235.78v-71.56\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol